export default __webpack_public_path__ + "static/media/diet.05cd52de.jpg";